import { useCallback, useState } from 'react';
import { FormField } from '../../UI/General/FormField';
import '../../../styles/Testimonial/testimonialVendor.scss';

/**
 * TestiVendor component for collecting event vendor information
 * Implements form controls for various event service providers
 */
function TestiVendor() {
  // State for form fields
  const [formValues, setFormValues] = useState({
    eventFlowers: '',
    eventPlanner: '',
    eventVenue: '',
    photographer: '',
    videographer: '',
    caterer: '',
  });

  /**
   * Generic handler for input changes
   * @param {Object} e - Event object
   */
  const handleInputChange = useCallback(e => {
    const { name, value } = e.target;

    setFormValues(prevValues => ({
      ...prevValues,
      [name]: value,
    }));
  }, []);

  return (
    <div className="testi-header-container" role="form" aria-labelledby="vendor-details-heading">
      <div className="testi-header-content">
        <h2 className="testi-header-subtitle" id="vendor-details-heading">
          Vendor Details
        </h2>
      </div>
      <p className="testi-header-description">
        Kindly share your event staff name or social media handle—we love to give credit where it's
        due!
      </p>

      {/* Row 1: Event Flowers, Event Planner, Event Venue */}
      <div className="testi-header-row">
        <FormField
          id="eventFlowers"
          label="Event Flowers"
          value={formValues.eventFlowers}
          onChange={handleInputChange}
          sanitize={true}
        />
        <FormField
          id="eventPlanner"
          label="Event Coordinator/Planner"
          value={formValues.eventPlanner}
          onChange={handleInputChange}
          ariaLabel="Event Planner (Optional)"
        />
        <FormField
          id="eventVenue"
          label="Event Venue"
          value={formValues.eventVenue}
          onChange={handleInputChange}
          ariaLabel="Event Venue (Optional)"
        />
      </div>

      {/* Row 2: Event Photographer, Event Videographer, Caterer */}
      <div className="testi-header-row">
        <FormField
          id="photographer"
          label="Event Photographer"
          value={formValues.photographer}
          onChange={handleInputChange}
        />
        <FormField
          id="videographer"
          label="Event Videographer"
          value={formValues.videographer}
          onChange={handleInputChange}
        />
        <FormField
          id="caterer"
          label="Caterer"
          value={formValues.caterer}
          onChange={handleInputChange}
          sanitize={true}
        />
      </div>
    </div>
  );
}

TestiVendor.propTypes = {
  // Add props as needed to match TestiHeader pattern
};

export { TestiVendor };
